import {useDebugValue} from 'react';

import classNames from 'classnames';

const classNamespace = 'search-form';
const dayClassName = `${classNamespace}__day`;

const dateClassName = 'date';
const pastClassName = 'past';
const todayClassName = 'today';

function useComponent(props) {
    const {
        ariaLabelDate,
        day,
        isPast,
        isToday
    } = props;

    const className = classNames(dayClassName, {
        [dateClassName]: true,
        [pastClassName]: isPast,
        [todayClassName]: isToday
    });

    const result = {
        className,
        day,
        ariaLabelDate
    };

    useDebugValue(result);

    return result;
}

export {useComponent};
